const Splash4 = () => {
  return (
    <div className="w-full relative bg-[#f2ece3] overflow-hidden flex flex-col items-start pt-[74px] px-[100px] pb-3 box-border gap-[62px] leading-[normal] tracking-[normal] text-left text-base text-[#353434] font-[Mingzat] lg:pl-[50px] lg:pr-[50px] lg:box-border mq750:gap-[31px] mq750:pl-[25px] mq750:pr-[25px] mq750:box-border mq450:gap-[15px]">
      <main className="flex items-start gap-[108px] max-w-full lg:flex-wrap mq750:gap-[54px] mq450:gap-[27px]">
        <img
          className="h-[800px] flex-1 relative rounded-[20px] max-w-full overflow-hidden object-cover min-w-[390px] mq750:min-w-full"
          loading="lazy"
          alt=""
          src="./Rectangle-6@2x.png"
        />
        <section className="flex flex-col items-end gap-[116px] max-w-full text-center text-[40px] text-[#fff] font-['Great_Vibes'] lg:flex-1 mq750:gap-[58px] mq1050:min-w-full mq450:gap-[29px]">
          <div className="h-[168px] flex items-start justify-end pt-0 px-4 pb-[30px] box-border">
            <div className="flex-1 flex flex-col items-start gap-1.5">
              <div className="self-stretch rounded-[10px] bg-[#1e1e1e] flex items-start pt-2.5 pb-[23px] pl-7 pr-[21px]">
                <div className="h-[104px] w-[244px] relative rounded-[10px] bg-[#1e1e1e] hidden shrink-0" />
                <div className="flex-1 relative z-[1] shrink-0 mq1050:text-[32px] mq450:text-2xl">
                  <span>Insta</span>
                  <span className="text-[64px] font-black font-['Kumbh_Sans']">
                    ED
                  </span>
                </div>
              </div>
              <div className="flex items-start py-0 pl-[7px] pr-0.5 text-left text-2xl text-[#000] font-['Maven_Pro']">
                <h3 className="m-0 relative text-[length:inherit] font-normal font-[inherit] mq450:text-[19px]">
                  Online Tuitions | 6-12
                </h3>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-start gap-[49px] max-w-full text-left text-4xl text-schemes-primary font-[Manrope] mq750:gap-6">
            <div className="flex flex-col items-start gap-[6.6px] max-w-full">
              <div className="relative font-extrabold mq1050:text-[29px] mq450:text-[22px]">
                <span>{`No `}</span>
                <span className="text-[64px]">Boring Lectures.</span>
              </div>
              <div className="h-12 relative font-extrabold inline-block max-w-full mq1050:text-[29px] mq450:text-[22px]">
                <span>No</span>
                <span className="text-[40px]">{` `}</span>
                <span className="text-[64px]">Silent Screens.</span>
              </div>
            </div>
            <h1 className="m-0 h-11 relative text-[32px] font-normal font-[inherit] text-[#000] inline-block mq1050:text-[26px] mq450:text-[19px]">
              classes where students can’t drift away
            </h1>
          </div>
          <div className="self-stretch flex items-start justify-center py-0 pl-5 pr-[108px] mq450:pr-5 mq450:box-border">
            <div className="flex flex-col items-end gap-11">
              <div className="flex items-start gap-4">
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#353434] h-[25px] w-[25px] relative rounded-[50%]" />
                <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
              </div>
              <div className="flex items-start justify-end py-0 pl-6 pr-[23px]">
                <button className="cursor-pointer border-[#948d8d] border-solid border-[1px] pt-3.5 pb-4 pl-[29px] pr-6 bg-[#fff] h-[67px] rounded-[5px] box-border flex items-start hover:bg-[#e6e6e6] hover:border-[#7a7373] hover:border-solid hover:hover:border-[1px] hover:box-border">
                  <div className="h-[67px] w-[183px] relative rounded-[5px] bg-[#fff] border-[#948d8d] border-solid border-[1px] box-border hidden shrink-0" />
                  <div className="relative text-2xl font-[Manrope] text-[#000] text-left z-[1] shrink-0">
                    Get Started
                  </div>
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="flex items-start py-0 px-[463px] box-border max-w-full lg:pl-[231px] lg:pr-[231px] lg:box-border mq750:pl-[115px] mq750:pr-[115px] mq750:box-border mq450:pl-5 mq450:pr-5 mq450:box-border">
        <div className="relative">
          {`2026 |  | `}
          <span className="[text-decoration:underline]">Terms of Use</span>
          {` | `}
          <span className="[text-decoration:underline]">Privacy Policy</span>
        </div>
      </div>
    </div>
  );
};

export default Splash4;
